import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/browser';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

if (environment.production && environment.sentryDsn) {
  Sentry.init({
    dsn: environment.sentryDsn,
    environment: (environment as any).sentryEnvironment || (environment.production ? 'production' : 'development'),
    release: `mydj@${(environment as any).appVersion || 'dev'}`,
    dist: ((environment as any).buildNumber !== undefined && (environment as any).buildNumber !== null)
      ? String((environment as any).buildNumber)
      : undefined,

    debug: false,

    integrations: [
      Sentry.browserTracingIntegration({
        tracePropagationTargets: [
          /localhost:4200/,
          /^https?:\/\/mydj\-prod\.ln3\.tempurl\.info/,
          /^https?:\/\/mydj\-dev\.ln3\.tempurl\.info/,
          /^https?:\/\/ycdapp\.ycda\.co\.il/,
          /^https?:\/\/wss\.win1\.tempurl\.info/,
          /^https?:\/\/localhost(:\d+)?/,
          /^https?:\/\/127\.0\.0\.1(:\d+)?/
        ]
      }),
      Sentry.replayIntegration()
    ],
    tracesSampleRate: 1.0, //  Capture 100% of the transactions (usually better to use 0.1 in production, 1.0 in development)
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,

    attachStacktrace: true,
    maxBreadcrumbs: 50,
    normalizeDepth: 8,
    ignoreErrors: [
      // 'ResizeObserver loop limit exceeded',
      // 'Script error',
      // 'Request aborted'
    ],
    denyUrls: [
      /extensions\//,
      /^chrome:\/\//,
      /safari-extension:/
    ],
    beforeSend(event) {
      if (event.request && event.request.url) {
        try {
          const u = new URL(event.request.url);
          u.search = '';
          event.request.url = u.toString();
        } catch {}
      }
      return event;
    }
  });
  // if (!environment.production) {
  //   Sentry.captureMessage('Sentry connectivity test');
  // }
  (window as any).Sentry = Sentry;
  Sentry.setTag('app', 'mydj');
  Sentry.setUser({ id: 'anonymous' });
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));

/*** Custom ***/
